import axios from "axios";
import { takeLatest, put } from "redux-saga/effects";

import { API_BASE_URI } from "../ApiCall";
import { CommentActionTypes } from "./Comment.type";

export function* fetchAllComments(action: any): any {
  try {
    let query = "";

    if (action.payload && Object.keys(action.payload).length > 0) {
      query =
        "?" +
        Object.keys(action.payload)
          .map((key) => `${key}=${action.payload[key]}`)
          .join("&");
    }

    const response = yield axios.get(`${API_BASE_URI}/comment${query}`);
    yield put({
      type: CommentActionTypes.FETCH_ALL_COMMENT_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({
      type: CommentActionTypes.FETCH_ALL_COMMENT_FAILURE,
      payload: error,
    });
  }
}

export function* fetchOneComments(action: any): any {
  try {
    const response = yield axios.get(
      `${API_BASE_URI}/comment/${action.payload}`
    );
    yield put({
      type: CommentActionTypes.FETCH_ONE_COMMENT_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({
      type: CommentActionTypes.FETCH_ONE_COMMENT_FAILURE,
      payload: error,
    });
  }
}

export function* watcherFetchAllComments() {
  yield takeLatest(CommentActionTypes.FETCH_ALL_COMMENT, fetchAllComments);
}

export function* watcherFetchOneComments() {
  yield takeLatest(CommentActionTypes.FETCH_ONE_COMMENT, fetchOneComments);
}
